import React, { memo } from 'react';

import type { SymbolProps } from '@/components/atomic/atoms/data-display/icons/symbol/typings';
import withExposer from '@/hocs/with-exposer';
import type { BasicComponentProps } from '@/typings/generic';

const SymbolComponent: React.FC<SymbolProps & BasicComponentProps> = ({
	id,
	viewBox,
	dangerouslySetInnerHTML,
}) => (
	<symbol
		id={id}
		viewBox={viewBox.join(' ')}
		dangerouslySetInnerHTML={dangerouslySetInnerHTML}
	/>
);

const Symbol = memo(withExposer(SymbolComponent, 'symbol'));

export default Symbol;
